<div class="alias-banner" *ngIf="isAliased()" role="status">
  <span class="alias-banner__text">
    You're viewing <strong>{{ vendorName() }}</strong> &middot; read-only guidance mode
  </span>
  <button
    type="button"
    class="alias-banner__end"
    (click)="endSession()"
    [disabled]="ending"
    aria-label="End alias session and return to the internal dashboard"
  >
    {{ ending ? 'Ending…' : 'End session' }}
  </button>
</div>
